import React from 'react';
import { Trans } from 'react-i18next';

export function LoginPageTitle({ businessLogin }) {
  return (
    <h1>
      <Trans i18nKey={businessLogin ? 'b2b_login_page_title' : 'login_page_title'}>
        Welcome back to <b>RIMI!</b>
      </Trans>
    </h1>
  );
}